// The widget is served from the agent's own domain (ebchatbot.fynity.in),
// so use a relative path to avoid CORS. Nginx proxies /api/ to the backend.
const API_BASE = (process.env.REACT_APP_SUPPORT_API_URL || '/api/support');

export const sendMessage = async ({ message, role, userId, orgId, token, conversationId, attachments }) => {
  const formData = new FormData();
  formData.append('message', message);
  formData.append('role', role);
  formData.append('user_id', userId);
  if (orgId) formData.append('org_id', orgId);
  if (conversationId) formData.append('conversation_id', conversationId);

  if (attachments?.length) {
    attachments.forEach((file) => formData.append('attachments', file));
  }

  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(`${API_BASE}/chat`, { method: 'POST', headers, body: formData });
  if (!response.ok) throw new Error('Failed to send message');
  return response.json();
};

export const getConversationHistory = async (conversationId, token) => {
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE}/conversation/${conversationId}`, { headers });
  if (!response.ok) throw new Error('Failed to fetch history');
  return response.json();
};

export const getLatestConversation = async ({ role, userId, orgId, token }) => {
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const params = new URLSearchParams();
  params.set('user_id', userId || '');
  if (role) params.set('role', role);
  if (orgId) params.set('org_id', orgId);
  const response = await fetch(`${API_BASE}/conversation/latest?${params}`, { headers });
  if (!response.ok) throw new Error('Failed to fetch latest conversation');
  return response.json();
};

export const escalateToAgent = async (conversationId, token) => {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE}/escalate`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ conversation_id: conversationId }),
  });
  if (!response.ok) throw new Error('Failed to escalate');
  return response.json();
};

export const getWidgetConfig = async () => {
  const response = await fetch(`${API_BASE}/config`);
  if (!response.ok) throw new Error('Failed to fetch widget config');
  return response.json();
};
